import { useMutation, useQuery } from "@tanstack/react-query";
import { createSport, editSport, getSports } from "modules/api";
import { ResponseSports, Sports, SportsParams } from "../types";
import { useState } from "react";
import { AxiosResponse } from "axios";
import { notifications } from "@mantine/notifications";
import { clearSession } from "services/store";

interface Props {
  refetch: () => void;
  id: number | null;
}

export function useEditSport(props: Props) {
  const { refetch, id } = props;
  // const { reFetch } = props;
  //   const [sports, setSports] = useState<ResponseSports>();
  const [isSuccess, setIsSuccess] = useState(false);
  //   const [error, setError] = useState<string>("");

  const { mutate: update, isPending: isLoading } = useMutation({
    mutationFn: (data: any) => editSport(data, id),
    retry: false,
    onSuccess: (res: AxiosResponse) => {
      setIsSuccess(true);

      refetch();
      //   setError("");
      //   const data = res?.data?.data;
      //   setSports(data);
      console.log("🚀 ~ useSports ~ data:", res);
    },
    onError: (e: any) => {
      notifications.show({
        title: `${e?.data?.message}`,
        message: null,
        color: "red",
      });
      const statusCode: number = e?.status;
      // statusCode === 401 && clearSession();
      //   setError("Internal server error");
      console.log("🚀 ~ useSports ~ e:", e);
    },
  });

  return { isSuccess, isLoading, update };
}
